export enum TranslationTagScope {
    None = 0,
    Key = 5,
    Language = 10
}
